import { isValidAmount } from 'modules/core/lib/formatCurrencyUtils'
import i18n from 'modules/core/lib/i18n'
import users from 'modules/core/store/collections/users'

import employees from 'modules/employees/store/collections/employees'
import { ImportData } from 'modules/payroll_bundle/lib/PayrollResultContext'

export const getUserFromImportData = (importData: ImportData) => {
  const employeeId = Number(importData.employee_id)
  const employee = employees.get(employeeId)

  return employee && users.get(employee.attributes.access_id)
}

const hasEmployeeAssigned = (importData: ImportData): boolean => {
  return !!(importData.employee_id && getUserFromImportData(importData))
}

export const validate = (importData: ImportData) => {
  const errors: Record<string, string> = {}

  if (!hasEmployeeAssigned(importData)) {
    errors['employee_id'] = i18n.t('payroll_bundle.sepa_generator.matcher.match.assign')
  }

  // Net salary is required (but can be 0), the other amounts are optional.
  // Numbers are received as strings when importing a CSV, and as numbers when
  // importing an Excel file.
  if (!isValidAmount(String(importData.net_salary))) {
    errors['net_salary'] = i18n.t('payroll_bundle.payroll_results.review_and_import.missing_data')
  }

  return ['gross_salary', 'company_costs'].reduce<Record<string, string>>(
    (errors, attributeName) => {
      const attributeValue = importData[attributeName]

      if (attributeValue && !isValidAmount(String(attributeValue).trim())) {
        errors[attributeName] = i18n.t(
          'payroll_bundle.payroll_results.review_and_import.missing_data'
        )
      }

      return errors
    },
    errors
  )
}

export const isValid = (importData: ImportData): boolean => {
  return Object.keys(validate(importData)).length === 0
}
